import styled from "styled-components";
import colors from "../../assets/styles/colors";

export const DetailExceptionContainer = styled.div`
height: 100%;
display: flex;
flex-direction: column;
justify-content: space-between;
padding: 44px 20px 15px 20px;
background: ${colors.bgGray};
`;

export const DetailExceptionWrapper = styled.div`
margin-bottom: 30px;
`;

export const DetailExceptionHeader = styled.div``;

export const DetailExceptionHeaderArea = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
`;

export const DetailExceptionHeaderTitle = styled.small`
font-size: 12px;
color: ${colors.textSecondary};
`;

export const DetailExceptionContent = styled.div`
  padding: 30px 0px;
`;

export const DetailExceptionSubtitle = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: ${colors.textPrimary};
`;

export const DetailExceptionGrid = styled.div`
  background: ${colors.white};
  padding: 15px;
  border-radius: 16px;
`;

export const DetailExceptionGridCol = styled.div`
  display: flex;
  flex-direction: column;

  & + & {
    margin-left: 20px;
  }
`;

export const DetailExceptionStrong = styled.strong`
  color: ${colors.textPrimary};
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
`;

export const DetailExceptionSpan = styled.span`
  color: ${colors.textPrimary};
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
`;

export const DetailExceptionGridRow = styled.div`
  display: flex;

  & + & {
    margin-top: 15px;
  }
`;

export const DetailExceptionGridIconArea = styled.div`
  display: flex;
  align-items: center;
`;

export const DetailExceptionGridIcon = styled.div`
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.background};
  border-radius: 8px;
  margin-right: 10px;
`;

export const DetailExceptionButtonArea = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;
